import * as ROUTES from "./routes";

export * as ROUTES from "./routes";
export default [
  {
    path: ROUTES.HOME,
    authRequired: false,
    component: "Home"
  },
  {
    path: ROUTES.SIGNIN,
    authRequired: false,
    component: "Login"
  },
  { 
    path: ROUTES.SIGNIN_TWO_FACTOR_CONFIRMATION,
    authRequired: false, 
    component: "Login", // Use same component as login. Let it detect that it's a 2fa login.
  },
  {
    path: ROUTES.SIGNUP,
    authRequired: false,
    component: "Register"
  },
  {
    path: ROUTES.REQUEST_PASSWORD_RESET, 
    authRequired: false, 
    component: "PasswordResetRequest"
  },
  {
    path: ROUTES.RESET_PASSWORD, 
    authRequired: false, 
    component: "PasswordReset"
  },
  {
    path: ROUTES.RESET_PASSWORD_TWO_FACTOR_AUTHENTICATION, 
    authRequired: false, 
    component: "PasswordReset" // Use same component as password reset. Let it detect that it's a 2fa reset.
  },
  {
    path: ROUTES.SHOP,
    authRequired: false,
    component: "Shop"
  },
  {
    path: ROUTES.BRAND,
    authRequired: false,
    component: "Brand",
  },
  {
    path: ROUTES.CATEGORY,
    authRequired: false,
    component: "Category"
  },
  {
    path: ROUTES.CART,
    authRequired: false,
    component: "Cart"
  },
  {
    path: ROUTES.CHECKOUT,
    authRequired: false,
    component: "Checkout"
  },
  {
    path: ROUTES.PRODUCT,
    authRequired: false,
    component: "Product"
  },
  {
    path: ROUTES.PAYMENT_STATUS,
    authRequired: false,
    component: "PaymentStatus",
  },
  {
    path: ROUTES.PAY_FOR_ORDER,
    authRequired: false,
    component: "OrderPayment",
  },
  {
    path: ROUTES.WISHLIST,
    authRequired: false,
    component: "Wishlist",
  },
  {
    path: ROUTES.VERIFY_EMAIL,
    authRequired: false,
    component: "EmailVerification"
  },
  {
    path: ROUTES.PRODUCT_COMPARE,
    authRequired: false,
    component: "ProductCompare"
  },
  {
    path: ROUTES.ORDER_TRACKING,
    authRequired: false,
    component: "OrderTracking"
  },
  {
    path: ROUTES.PRIVACY_POLICY,
    authRequired: false,
    component: "PrivacyPolicy"
  },
  { 
    path: ROUTES.ABOUT_US,
    authRequired: false,
    component: "AboutUs"
  },
  {
    path: ROUTES.CONTACT_US,
    authRequired: false,
    component: "ContactUs"
  },
  {
    path: ROUTES.SEARCH,
    authRequired: false,
    component: "Search",
  },
  {
    path: ROUTES.ORDER_LISTING,
    authRequired: true,
    component: "OrderListing",
  },
  {
    path: ROUTES.ORDER_DETAILS,
    authRequired: true,
    component: "OrderDetails",
  }
];
